import Model from './Model'

export default class Mailformstyle extends Model {
    resource() {
        return 'mailformstyle';
    }



    // update mailform formStyle
    formStyleUpdate(data) {
        return this.request({
            url: `${this.resource()}/${data.id}`,
            method: 'put',
            data: {
                name: data.name,
                styles: data.styles, 
            }
        });
    }


    // delete mailform formStyle
    formStyleDelete(id) {
        return this.request({
            url: `${this.resource()}/${id}`,
            method: 'delete',
        });
    }
}
